// extracted by mini-css-extract-plugin
module.exports = {"root":"autocomplete-list_root__1_Lt7","typeprimary":"autocomplete-list_typeprimary__OntNR","typesecondary":"autocomplete-list_typesecondary__STzex"};